// Generated by CoffeeScript 2.7.0
import Admin__CascadedSelectsController from './cascaded_selects.js';

Skylark.App.Controllers.register({Admin__CascadedSelectsController});
